import EventDownloadReportButton from './event-download-report';
import EventCheckQrGenerate from './event-check-qr-generate';


const EventActionItems = {
    DownloadReport: EventDownloadReportButton,
    CheckQrGenerate: EventCheckQrGenerate,
};


export default EventActionItems;
